export default __webpack_public_path__ + "static/media/search_icon2.0d10e86b.svg";